import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { DeviceGroup, DeviceGroupType } from "../../DiscoveryEngine.TS/Core/DeviceGroup";
import { DtoBase } from "../DtoBase";
import { ViewerDeviceGroupContainerDto } from "./ViewerDeviceGroupContainerDto";
import { ViewerDeviceGroupDto } from "./ViewerDeviceGroupDto";

export class ViewerDeviceGroupContainerNames {
	public static readonly Root = "";
	public static readonly DeviceCategories = "Categories";
	public static readonly UserGroups = "User Groups";
}

export class ViewerDeviceGroupContainerGUIDs {
	public static readonly Root = "1ab128be-3445-4e77-a110-bc055bf475d7";
	public static readonly DeviceCategories = "e2e024cf-c3ed-4c4a-a724-d8135807e684";
	public static readonly UserGroups = "560ed1ec-98bb-498a-8dee-1dca357bb293";
	public static readonly Subnets = "9acecd87-a84b-4cea-bce5-2f6b1574801b";
	public static readonly Vlans = "c5ba8bdb-790d-4a23-a7ab-efe35a8a1122";
	public static readonly Wireless = "7450d4b7-df55-44f0-bfda-948a493dba74";
	public static readonly Vmware = "499459b0-ef83-4890-bb73-f6e3f885a4cd";
	public static readonly Hyperv = "154af1b7-9664-4a7b-9adb-d1eb1b98dc8a";
}

export class ViewerDeviceGroupNames {
	public static readonly DevicesAll = "All Devices";
	public static readonly DevicesSnmp = "All SNMP Devices";
	public static readonly DevicesRouters = "Routers";
	public static readonly DevicesSwitches = "Switches";
	public static readonly DevicesWirelessControllers = "Wireless Controllers";
	public static readonly DevicesWirelessAps = "Wireless APs";
	public static readonly DevicesVirtualHosts = "Virtual Hosts";
	public static readonly DevicesVirtualMachines = "Virtual Machines";
	public static readonly DevicesPrinters = "Printers";
	public static readonly DevicesApple = "Apple";
	public static readonly DevicesWindows = "Windows";
	public static readonly DevicesWindowsServers = "Windows Servers";
	public static readonly DevicesIpPhoneManagers = "IP Phone Managers";
	public static readonly DevicesIpPhones = "IP Phones";
	public static readonly DevicesOther = "Other";
	public static readonly IpScopesSubnets = "Subnets";
	public static readonly IpScopesVlans = "VLANs";
	public static readonly WirelessWirelessControllers = "Wireless Controllers";
	public static readonly WirelessWirelessAps = "Wireless APs";
	public static readonly WirelessWirelessClients = "Wireless Clients";
	public static readonly WirelessRogueDevices = "Rogue Devices";
	public static readonly VmwareVirtualHosts = "Virtual Hosts";
	public static readonly VmwareVirtualMachines = "Virtual Machines";
	public static readonly VmwareVsphere = "VMware vSphere";
	public static readonly VmwareVcenter = "VMware vCenter";
	public static readonly HypervVirtualHosts = "Virtual Hosts";
	public static readonly HypervVirtualMachines = "Virtual Machines";
	public static readonly DevicesCore = "All Core Devices";
	public static readonly WirelessCoreDevices = "All Core Devices";
	public static readonly VmwareCoreDevices = "All Core Devices";
	public static readonly HypervCoreDevices = "All Core Devices";
	public static readonly VmwareVirtualSwitches = "Virtual Switches";
	public static readonly VmwareAllDevices = "All Devices";
	public static readonly HypervAllDevices = "All Devices";
}

export class ViewerDeviceGroupGUIDs {
	public static readonly DevicesAll = "3e3682f2-415a-4e54-965f-e1db1cf8dfe4";
	public static readonly DevicesSnmp = "37b27561-9eac-4083-87cc-9e647ff2f8d6";
	public static readonly DevicesRouters = "c5b4a21f-77fa-4cee-9d95-b3f6456ec2fb";
	public static readonly DevicesSwitches = "80c47ace-4ebd-459d-8f39-82df9853cffd";
	public static readonly DevicesWirelessControllers = "7603baee-e978-4c21-af81-88d08a6c28b2";
	public static readonly DevicesWirelessAps = "37a20f9d-8f50-4fe8-a59f-9e445b2446ba";
	public static readonly DevicesVirtualHosts = "cc1ccacc-14cf-4603-bcba-454d72843ceb";
	public static readonly DevicesVirtualMachines = "73e2b757-2dc4-4aab-8927-0107d51b7902";
	public static readonly DevicesPrinters = "430b9d33-77de-4a38-b4ba-37fba35ca3bd";
	public static readonly DevicesApple = "acabfe82-9402-426c-bf15-dfb372028ec5";
	public static readonly DevicesWindows = "03fb80dd-4423-4d04-9b05-1ef94dc3209c";
	public static readonly DevicesWindowsServers = "bb118299-c6dd-4c6f-893a-690dea326893";
	public static readonly DevicesIpPhoneManagers = "e58917dc-7253-4c82-b63e-a171b6054110";
	public static readonly DevicesIpPhones = "41d135b4-5afc-4052-bea6-1ef3d9926fd7";
	public static readonly IpScopesSubnets = "890f8162-1e8f-4737-acd0-ce6d635a0647";
	public static readonly IpScopesVlans = "07a1ff00-1706-4c9e-8e05-1f78f30d175a";
	public static readonly WirelessWirelessControllers = "87c000c3-b7f8-412b-82be-d8207e9569fb";
	public static readonly WirelessWirelessAps = "2839d61d-6d80-4273-9bb7-e1d51c15cb2c";
	public static readonly WirelessWirelessClients = "c606d245-7e7d-4c08-a3b1-8e8cb833c945";
	public static readonly WirelessRogueDevices = "fd78be0c-8217-46a1-b1ec-ad86a4c52851";
	public static readonly VmwareVirtualHosts = "0f2b8aa7-a94f-4c03-88b4-bf420b602464";
	public static readonly VmwareVirtualMachines = "7f576aec-3e0a-437d-a01a-d675235e7d0c";
	public static readonly DevicesOther = "c3e0187d-f7f6-4c8d-b652-87e25ae91a17";
	public static readonly VmwareVsphere = "50aaf56c-ba12-4c00-a7df-d14fb53579e2";
	public static readonly VmwareVcenter = "922e64c9-3137-49c8-8d49-b8c36ee10f36";
	public static readonly HypervVirtualHosts = "7d9164d3-75f2-4c81-88ae-da98d63e019c";
	public static readonly HypervVirtualMachines = "f00c695a-2cbf-4186-9234-8ba874b888e5";
	public static readonly DevicesCore = "fcfe209b-ea81-4c1c-b57c-da6aab633138";
	public static readonly WirelessCoreDevices = "2e76bd76-70ef-4db4-9982-c1bd435f8f0c";
	public static readonly VmwareCoreDevices = "519d9c1a-d62a-4cbc-8c9e-983094f31778";
	public static readonly HypervCoreDevices = "97545ff2-8605-46c8-8d9c-b470eef822cb";
	public static readonly VmwareVirtualSwitches = "e1f7f5b3-1cdd-4938-b7e0-3c72611d28ac";
	public static readonly VmwareAllDevices = "5a1b4399-21a2-4d75-84d4-a049bb3358d6";
	public static readonly HypervAllDevices = "ff8481a0-7427-437c-bad3-66b22ee60b0b";

	public static Primary =
	[
		ViewerDeviceGroupGUIDs.DevicesAll,
		ViewerDeviceGroupGUIDs.DevicesCore,
		ViewerDeviceGroupGUIDs.DevicesSnmp,
		ViewerDeviceGroupGUIDs.DevicesRouters,
		ViewerDeviceGroupGUIDs.DevicesSwitches,
		ViewerDeviceGroupGUIDs.DevicesWirelessControllers,
		ViewerDeviceGroupGUIDs.DevicesWirelessAps,
		ViewerDeviceGroupGUIDs.DevicesVirtualHosts,
		ViewerDeviceGroupGUIDs.DevicesVirtualMachines,
		ViewerDeviceGroupGUIDs.DevicesPrinters,
		ViewerDeviceGroupGUIDs.DevicesApple,
		ViewerDeviceGroupGUIDs.DevicesWindows,
		ViewerDeviceGroupGUIDs.DevicesWindowsServers,
		ViewerDeviceGroupGUIDs.DevicesIpPhoneManagers,
		ViewerDeviceGroupGUIDs.DevicesIpPhones,
		ViewerDeviceGroupGUIDs.DevicesOther,
	];
}

export class ViewerDeviceGroupTreeDto extends DtoBase {

	public Containers: List<ViewerDeviceGroupContainerDto>;
	public Groups: List<ViewerDeviceGroupDto>;

	constructor() {
		super();

		this.Containers = new List<ViewerDeviceGroupContainerDto>();
		this.Groups = new List<ViewerDeviceGroupDto>();
	}

	public get HasContainers(): boolean {
		return (this.Containers && this.Containers.Count > 0);
	}

	public get HasGroups(): boolean {
		return (this.Groups && this.Groups.Count > 0);
	}

	public AddContainer(value: ViewerDeviceGroupContainerDto): void {
		this.Containers.Add(value);
	}

	public AddGroup(value: ViewerDeviceGroupDto): void {
		this.Groups.Add(value);
		//if (value.HasContainerParentGuid) {
		//	let parentContainer = this.Containers.Values.find((container) => container.Guid === value.ContainerParentGuid);
		//	if (parentContainer) parentContainer.GroupGuids.Add(value.Guid);
		//	else console.error("Parent container is null");
		//}
		//else if (value.HasGroupParentGuid) {
		//	let parentGroup = this.Groups.Values.find((group) => group.Guid === value.GroupParentGuid);
		//	if (parentGroup) parentGroup.ChildGroupGuids.Add(value.Guid);
		//	else console.error("Parent group is null");
		//}
		//else {
		//	console.error("Group has no parent");
		//}
	}

	public FindContainerByGuid(guid: string): ViewerDeviceGroupContainerDto {
		for (let i: number = 0; i < this.Containers.Count; ++i) {
			if (this.Containers.Get(i).Guid === guid)
				return this.Containers.Get(i);
		}
		return null;
	}

	public FindGroupByGuid(guid: string): ViewerDeviceGroupDto {
		for (let i: number = 0; i < this.Groups.Count; ++i) {
			if (this.Groups.Get(i).Guid === guid)
				return this.Groups.Get(i);
		}
		return null;
	}

	public get RootContainer(): ViewerDeviceGroupContainerDto {
		for (let i: number = 0; i < this.Containers.Count; ++i) {
			if (!this.Containers.Get(i).Name)
				return this.Containers.Get(i);
		}
		return new ViewerDeviceGroupContainerDto();
	}

	public FindContainerByTagGuid(tagGuid: string): ViewerDeviceGroupContainerDto {
		for (let i: number = 0; i < this.Containers.Count; ++i) {
			let container = this.Containers.Get(i);
			if (container.TagGuid == tagGuid)
				return container;
		}
		return null;
	}

	public FindGroupByTagGuid(tagGuid: string): ViewerDeviceGroupDto {
		for (let i: number = 0; i < this.Groups.Count; ++i) {
			let group = this.Groups.Get(i);
			if (group.TagGuid == tagGuid)
				return group;
		}
		return null;
	}

	public ConfigureOtherGroup() {
		let categoriesContainer = this.DeviceCategoriesGroupsContainer;
		if (categoriesContainer) {
			let otherVdg = this.FindGroupByTagGuid(ViewerDeviceGroupGUIDs.DevicesOther);
			if (otherVdg) {
				let otherDg = otherVdg.DeviceGroup;
				console.assert(otherDg.Type == DeviceGroupType.Other);

				let excludedGroups = [
					ViewerDeviceGroupGUIDs.DevicesAll,
					ViewerDeviceGroupGUIDs.DevicesCore,
					ViewerDeviceGroupGUIDs.DevicesSnmp,
					ViewerDeviceGroupGUIDs.DevicesOther,
				];

				otherDg.OtherGroups = new List<DeviceGroup>();
				categoriesContainer.GroupGuids.ForEach((groupGuid: string) => {
					let vdg = this.FindGroupByGuid(groupGuid);
					let dg = vdg.DeviceGroup;
					if (excludedGroups.indexOf(dg.GUID) < 0) {
						otherDg.OtherGroups.Add(dg);
					}
				});
			}
		}
	}

	public Write(obj: any, context: any): void {
		obj.viewer_device_group_tree = {};
		obj = obj.viewer_device_group_tree;

		super.Write(obj, context);

		if (this.HasContainers) {
			obj.containers = [];
			ObjSerUtils.WriteObjSerCollection(obj.containers, this.Containers, context);
		}

		if (this.HasGroups) {
			obj.groups = [];
			ObjSerUtils.WriteObjSerCollection(obj.groups, this.Groups, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.viewer_device_group_tree)
			throw new Error();
		obj = obj.viewer_device_group_tree;

		super.Read(obj, context);

		if (obj.containers !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.containers, this.Containers,
				(value: any) => new ViewerDeviceGroupContainerDto(), context);
		}

		if (obj.groups !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.groups, this.Groups,
				(value: any) => new ViewerDeviceGroupDto(), context);
		}
	}

	public get TopLevelContainers(): ViewerDeviceGroupContainerDto[] {
		let result: ViewerDeviceGroupContainerDto[] = [];
		let rootContainer = this.RootContainer;
		if (rootContainer) {
			rootContainer.ContainerGuids.ForEach((containerGuid: string) => {
				let container = this.FindContainerByGuid(containerGuid);
				if (container) {
					result.push(container);
				}
			}, this);
		}
		return result;
	}

	public get UserGroupsContainer(): ViewerDeviceGroupContainerDto {
		return this.FindContainerByTagGuid(ViewerDeviceGroupContainerGUIDs.UserGroups);
	}

	public get DeviceCategoriesGroupsContainer(): ViewerDeviceGroupContainerDto {
		return this.FindContainerByTagGuid(ViewerDeviceGroupContainerGUIDs.DeviceCategories);
	}

	public GetContainerGroups(container: ViewerDeviceGroupContainerDto): ViewerDeviceGroupDto[] {
		let result: ViewerDeviceGroupDto[] = [];
		if (container) {
			container.GroupGuids.ForEach((groupGuid: string) => {
				let group = this.FindGroupByGuid(groupGuid);
				if (group) {
					result.push(group);
				}
			}, this);
		}
		return result;
	}

	public GetContainerParent(guid: string): ViewerDeviceGroupContainerDto {
		for (let i = 0; i < this.Containers.Count; ++i) {
			let container = this.Containers.Get(i);
			if (container.ContainerGuids.Contains(guid)) {
				return container;
			}
		}
		return null;
	}

	public GetGroupParent(guid: string): ViewerDeviceGroupContainerDto {
		for (let i = 0; i < this.Containers.Count; ++i) {
			let container = this.Containers.Get(i);
			if (container.GroupGuids.Contains(guid)) {
				return container;
			}
		}
		return null;
	}
}
